// extracted by mini-css-extract-plugin
module.exports = {"AddGiftByURL":"styles_AddGiftByURL__3lNk5","title":"styles_title__3XbG1","text":"styles_text__1fzP8"};